<script setup lang="ts">
const route = useRoute()
const props = defineProps<{
  brandName: string
  overall_rating: number
  hasReview?: boolean
  section?: string
  location?: { city?: string | null, state?: string | null }
  role?: string | null
  permalink?: string
}>()
const companySlug = computed(() => {
  if (props.permalink) return props.permalink
  const params = route.params.permalink as string[]
  return params[0]
})

const headerTitle = computed(() => {
  return props.brandName
})
</script>

<template>
  <div class="w-full lg:grid lg:grid-cols-2 lg:gap-8 flex flex-col gap-4">
    <div class="flex flex-col lg:flex-row lg:items-center lg:space-x-6 space-y-2 lg:space-y-0">
      <div class="text-3xl font-bold whitespace-nowrap">
        {{ headerTitle }}
      </div>
      <div class="flex items-center space-x-4 flex-wrap">
        <NuxtLink
          :to="`/company/${companySlug}/reviews`"
          class="underline text-lg whitespace-nowrap"
        >
          {{ hasReview ? "Update My Review" : "Write a Review" }}
        </NuxtLink>
        <span class="text-lg">|</span>
        <span class="text-lg">{{ overall_rating }}</span>
        <span class="text-lg">|</span>
        <RatingStars
          :rating="overall_rating"
          size="md"
        />
      </div>
    </div>
    <div class="lg:flex lg:items-center lg:justify-end">
      <CompanyBreadcrumb
        :brand-name="brandName"
        :section="section"
        :location="location"
        :role="role"
        :permalink="permalink"
      />
    </div>
  </div>
</template>
